function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import cn from 'classnames';
import { renderFromComponentMap } from '@goodrx/x-core';
import { getSchemaFAQPage } from '@goodrx/x-core';
import Head from 'next/head';
import { Accordion } from './components';
export const QuestionAndAnswerGallery = props => {
  const {
    className,
    questionAndAnswerPairsCollection,
    type
  } = props;
  const questionAndAnswerPairsCollectionWithDefault = questionAndAnswerPairsCollection || {
    items: []
  };
  const faqSchema = getSchemaFAQPage({
    items: questionAndAnswerPairsCollectionWithDefault.items.map(item => ({
      answer: (item === null || item === void 0 ? void 0 : item.answer) || '',
      question: (item === null || item === void 0 ? void 0 : item.question) || ''
    }))
  });
  const componentMap = {
    default: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("script", {
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(faqSchema)
      },
      type: "application/ld+json"
    })), /*#__PURE__*/React.createElement(Accordion, _extends({}, props, {
      className: cn(className, 'questionAndAnswerGalleryType')
    }))),
    divider: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("script", {
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(faqSchema)
      },
      type: "application/ld+json"
    })), /*#__PURE__*/React.createElement(Accordion, _extends({}, props, {
      className: cn(className, 'questionAndAnswerGalleryType'),
      divider: true
    })))
  };
  return renderFromComponentMap(componentMap, type || 'default');
};